import {useCallback} from 'react'

import {useTableInstance} from '../../../hooks/tanstack-table/providers/table-provider'

/** Get all visible rows in the table, filtering out parent group rows and rows that are collapsed. */
export const useGetVisibleRows = () => {
  const table = useTableInstance()
  return useCallback(() => {
    const flatRows = table.getRowModel().flatRows
    return flatRows.filter(r => !r.getIsGrouped() && r.getIsAllParentsExpanded())
  }, [table])
}
